exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.v-table tbody td[data-v-0e91a510] {\n  height: 25px;\n}", ""]);

// exports
